import Amex from '@assets/images/banks/amex.svg';
import Diners from '@assets/images/banks/diners.svg';
import Discover from '@assets/images/banks/discover.svg';
import Jcb from '@assets/images/banks/jcb.svg';
import Mastercard from '@assets/images/banks/mastercard.svg';
import Visa from '@assets/images/banks/visa.svg';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';

import { CardType } from 'types';

export const months = [
  { value: '1', label: 'JANUARY' },
  { value: '2', label: 'FEBRUARY' },
  { value: '3', label: 'MARCH' },
  { value: '4', label: 'APRIL' },
  { value: '5', label: 'MAY' },
  { value: '6', label: 'JUNE' },
  { value: '7', label: 'JULE' },
  { value: '8', label: 'AUGUST' },
  { value: '9', label: 'SEPTEMBER' },
  { value: '10', label: 'OCTOBER' },
  { value: '11', label: 'NOVEMBER' },
  { value: '12', label: 'DECEMBER' }
];

export const cardOptions = [
  { value: '0', label: 'Do Not Use' },
  { value: '1', label: 'Use as Primary' },
  { value: '2', label: 'Use as Alternate' }
];

export const BANK_ICONS: { [key in CardType]: string | StaticImport } = {
  amex: Amex,
  visa: Visa,
  discover: Discover,
  electron: Visa,
  mastercard: Mastercard,
  diners: Diners,
  dinersBlanche: Diners,
  jcb: Jcb
};

const INVALID_DATE = 'Invalid Expiration Date';
const INVALID_CARD_NUMBER = 'Invalid Credit Card Number';

export const getApiError = (key: string, message: string): string => {
  switch (key) {
    case 'card_number':
      return message.includes(INVALID_CARD_NUMBER) ? message : '';
    case 'exp_month':
      return message.includes(INVALID_DATE) ? message : '';
    case 'exp_year':
      return message.includes(INVALID_DATE) ? message : '';
    default:
      return '';
  }
};
